import { apiCMSWithToken } from './axios'

export const url = {
  houseViewingAuction: `/house-viewing-auction`
}

export async function getHouseViewAuction(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.houseViewingAuction}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function AuctionViewHistoryDelete(id) {
  try {
    const response = await apiCMSWithToken.delete(
      `${url.houseViewingAuction}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function AuctionViewHistoryUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${url.houseViewingAuction}/${id}/update-status`,
    body
  )
  return response
}


// export async function pakageCommunityAdd(body) {
//   const response = await apiCMSWithToken.post(`${url.pakageCommunity}`, body)
//   return response
// }

// export async function pakageCommunityUpdate(body, id) {
//   const response = await apiCMSWithToken.put(
//     `${url.pakageCommunity}/${id}`,
//     body
//   )
//   return response
// }

// export async function pakageCommunityDetail(id) {
//   try {
//     const response = await apiCMSWithToken.get(`${url.pakageCommunity}/${id}`)

//     return response
//   } catch (error) {
//     console.error('Error in issueSearch:', error)
//     throw error
//   }
// }

// export async function deleteItemPakge(body) {
//   try {
//     const response = await apiCMSWithToken.delete(`${url.pakageCommunity}`, {
//       data: body
//     })
//     return response
//   } catch (error) {
//     console.error('Error in postSearch:', error)
//     throw error
//   }
// }

// export async function getPakageCommunityHistory(p = {}) {
//   try {
//     const params = new URLSearchParams({ ...p })
//     const response = await apiCMSWithToken.get(
//       `${url.pakageCommunity}/history?${params.toString()}`
//     )
//     return response
//   } catch (error) {
//     console.error('Error in postSearch:', error)
//     throw error
//   }
// }

export default {
  getHouseViewAuction,
  AuctionViewHistoryDelete,
  AuctionViewHistoryUpdate
  // pakageCommunityAdd,
  // pakageCommunityUpdate,
  // pakageCommunityDetail,
  // deleteItemPakge,
  // getPakageCommunityHistory
}
